export const QuizState = {
  LOADING: 'loading',
  SHOWING_QUESTION: 'showing-question',
  SUBMITTING_ANSWER: 'submitting-answer',
  SHOWING_ANSWER: 'showing-answer',
  FINISHED: 'finished',
  INSUFFICIENT_GAS: 'insufficient-gas',
  API_ERROR: 'api-error'
}
